import React from 'react';
import { cn } from '@/lib/utils';
import { WHATSAPP_SUPPORT_URL } from '@/lib/support';
import WhatsAppIcon from './WhatsAppIcon';

interface WhatsAppButtonProps {
  children?: React.ReactNode;
  /** Pre-filled message, e.g. a claim ID to quote. Defaults to the general support message. */
  href?: string;
  showIcon?: boolean;
  className?: string;
}

/** Green "Start chat" button that opens Protega support on WhatsApp. */
const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({ children = 'Start chat', href = WHATSAPP_SUPPORT_URL, showIcon = true, className }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={cn(
      'tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-2 tw-rounded-[10px] tw-bg-ds-whatsapp-bg tw-px-[14px] tw-py-[9px] tw-text-[13px] tw-font-semibold tw-leading-[18px] tw-text-ds-whatsapp-fg',
      'hover:tw-brightness-95 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ds-brand',
      className,
    )}
  >
    {showIcon && <WhatsAppIcon size={16} />}
    {children}
  </a>
);

export default WhatsAppButton;
